@if (!loadingPage()) {
  <div class="page">
    <div class="header">
      <h1 class="header-title">
        <mat-icon>edit_calendar</mat-icon>
        <span>Dagdelen</span>
      </h1>
    </div>

    <div class="wrapper">
      <mat-tab-group animationDuration="500ms" mat-stretch-tabs (selectedTabChange)="changeTab($event)">
        <mat-tab label="Chauffeur">
          <div *ngTemplateOutlet="daypartsTemplate"></div>
        </mat-tab>
        @if (this.usesPlannerPlanning()) {
          <mat-tab label="Planner">
            <div *ngTemplateOutlet="daypartsTemplate"></div>
          </mat-tab>
        }
        <mat-tab label="Uitzondering">
          <div *ngTemplateOutlet="exceptionsTemplate"></div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
  <button mat-fab extended color="primary" (click)="type() === 'exceptions' ? manageException() : addDayPart()">
    <mat-icon>add</mat-icon>
  </button>

  <ng-template #daypartsTemplate>
    <mat-card class="content">
      <div class="list-items">
        <div class="list-item-wrapper headers">
          <div class="list-item-col-wrapper">
            <div class="list-item-col">Dag</div>
            <div class="list-item-col unimportant">Titel</div>
            <div class="list-item-col">Tijd</div>
            <div class="list-item-col"></div>
          </div>
        </div>
        <cdk-virtual-scroll-viewport itemSize="50px" class="list-wrapper">
          @for (daypart of dayparts(); track daypart.id) {
            <div
              class="list-item-col-wrapper"
              role="button"
              tabindex="0"
              aria-label="Dagdeel openen"
              (click)="editDaypart(daypart, daypart.id)"
              (keydown.enter)="editDaypart(daypart, daypart.id)"
              (keydown.space)="$event.preventDefault(); editDaypart(daypart, daypart.id)"
            >
              <div class="list-item-col">
                {{
                  ucFirst(
                    moment()
                      .day(daypart.day + 1)
                      .format('dddd')
                  )
                }}
              </div>
              <div class="list-item-col unimportant">
                {{ daypart.name }}
              </div>
              <div class="list-item-col">
                van {{ daypart.startHour }}:{{ daypart.startMin }} tot {{ daypart.endHour }}:{{ daypart.endMin }}
              </div>
              <div class="list-item-col">
                <div class="list-item-buttons">
                  <button mat-icon-button aria-label="Dagdeel bewerken">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    aria-label="Dagdeel verwijderen"
                    (click)="removeDaypart(daypart); $event.stopPropagation()"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          }
          <div class="list-item-col-wrapper"></div>
        </cdk-virtual-scroll-viewport>
      </div>
      @if (dayparts().length === 0 && loading() === false) {
        <p class="no-items">Er zijn nog geen dagdelen aangemaakt.</p>
      }
    </mat-card>
  </ng-template>

  <ng-template #exceptionsTemplate>
    <mat-card class="content">
      @if (loading() === false) {
        <div class="list-items">
          <div class="list-item-wrapper headers">
            <div class="list-item-col-wrapper">
              <div class="list-item-col">Uitzondering</div>
              <div class="list-item-col">Datum</div>
              <div class="list-item-col unimportant">Herhaald</div>
              <div class="list-item-col unimportant2">Tijd</div>
              <div class="list-item-col"></div>
            </div>
          </div>
          <cdk-virtual-scroll-viewport itemSize="50px" class="list-wrapper">
            @for (exception of exceptions(); track exception.id) {
              <div
                class="list-item-col-wrapper"
                role="button"
                tabindex="0"
                aria-label="Uitzondering openen"
                (click)="manageException(exception)"
                (keydown.enter)="manageException(exception)"
                (keydown.space)="$event.preventDefault(); manageException(exception)"
              >
                <div class="list-item-col">
                  {{ exception.title }}
                </div>
                <div class="list-item-col">
                  {{ moment(exception.date.toDate()).format('DD/MM/YYYY') }}
                </div>
                <div class="list-item-col unimportant">
                  {{ repeatValues[exception.repeatValue] }}
                </div>
                <div class="list-item-col unimportant2">
                  {{ exception.allDay ? 'Hele dag' : getTimeString(exception) }}
                </div>
                <div class="list-item-col">
                  <div class="list-item-buttons">
                    <button mat-icon-button aria-label="Uitzondering bewerken">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button
                      mat-icon-button
                      aria-label="Uitzondering verwijderen"
                      (click)="deleteException(exception); $event.stopPropagation()"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            }
            <div class="list-item-col-wrapper"></div>
          </cdk-virtual-scroll-viewport>
        </div>
      }
      @if (exceptions().length === 0 && loading() === false) {
        <p class="no-items">Er zijn nog geen uitzonderingen aangemaakt.</p>
      }
    </mat-card>
  </ng-template>
}
@if (loadingPage()) {
  <div class="loading-wrapper" role="status" aria-live="polite" aria-atomic="true">
    <div class="loading">
      <mat-spinner></mat-spinner>
    </div>
  </div>
}
